export default __webpack_public_path__ + "static/media/SprintLogistics.c1d526d0.png";